module.exports = __webpack_public_path__ + "static/media/history_16.9b9d4da5.jpg";